import React, { FC, useState, memo, useEffect } from 'react';

const imageCache = new Set<string>();

interface ImageWithLoaderProps {
    src: string;
    alt?: string;
    className?: string;
    style?: React.CSSProperties;
    cache?: boolean;
}

const ImageWithLoader: FC<ImageWithLoaderProps> = ({ src, alt = 'Image', className, style, cache = false }) => {
    const [hasError, setHasError] = useState(false);
    const [loaded, setLoaded] = useState(cache && !!src && imageCache.has(src));
    const [srcValue, setSrcValue] = useState(src);

    useEffect(() => {
        if (srcValue !== src) {
            setSrcValue(src);
            setHasError(false);
            setLoaded(cache && !!src && imageCache.has(src));
        }
    }, [src]);

    const handleLoad = () => {
        if (cache && src) imageCache.add(src);
        setLoaded(true);
    };

    if (!src) {
        return (
            <div className={`relative w-max h-max ${className || ""}`}>
                <img src={'/assets/images/NoImage.png'} alt={alt} className={`!object-contain ${className || ""}`} style={style} />
            </div>
        );
    }

    return (
        <div className={`relative w-max h-max ${className || ""}`}>
            {!loaded && (
                <img
                    src={'/assets/images/Loading.gif'}
                    alt="Loading"
                    style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        ...style
                    }}
                />
            )}
            <img
                src={hasError ? '/assets/images/NoImage.png' : src}
                alt={alt}
                className={`!object-contain ${className || ""}`}
                style={style}
                onError={() => {
                    setHasError(true);
                    setLoaded(true)
                }}
                onLoad={handleLoad}
            />
        </div>

    );
};

export default memo(ImageWithLoader);
